<h3>Edit Display Name</h3>
<mat-dialog-content>
    <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Display Name</mat-label>
            <input matInput max="155" placeholder="" matToolTipClass="form-helper-tooltip" matTooltipPosition="above" matTooltip="If included your listing will display: Display Name in City, State" [(ngModel)]="displayName">
            <mat-hint>Currently set as <i>{{data}}</i></mat-hint>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button class="metallic-text-btn-red" type="button" (click)="cancel.emit()"><mat-icon matPrefix>cancel</mat-icon>Canel</button>
    <button mat-flat-button class="metallic-text-btn-blue" type="button" (click)="save.emit(displayName)"><mat-icon matPrefix>save</mat-icon>Save</button>
</mat-dialog-actions>


